import { PaginationBar } from 'mailup-web-components'
import PropTypes from 'prop-types'

import { modalSmsMessagesPaginationState } from 'Hooks/useModalSmsMessages/useModalSmsMessages'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

const Pagination = ({ showSizeList = false }) => {
  const intl = useIntl()

  const [{ pageNumber, pageSize, totalItems }, setPageState] = useRecoilState(
    modalSmsMessagesPaginationState
  )

  const handleChangePage = (page) => {
    setPageState((prev) => ({
      ...prev,
      pageNumber: page
    }))
  }

  const handleChangePageSize = (page) => {
    setPageState((prev) => ({
      ...prev,
      pageSize: page
    }))
  }

  return (
    <PaginationBar
      data-mu-test='sms-messages-pager'
      pageNumber={pageNumber}
      pageSize={pageSize}
      totalItems={totalItems}
      minPageSize={showSizeList ? 5 : totalItems}
      handleChangePage={handleChangePage}
      handleChangePageSize={handleChangePageSize}
      strings={{
        of: intl.formatMessage({ id: 'Load.Pager.Of' }),
        label: intl.formatMessage({ id: 'Load.Pager.Items' })
      }}
    />
  )
}

Pagination.propTypes = {
  showSizeList: PropTypes.bool
}

Pagination.defaultProps = {
  showSizeList: false
}

export default Pagination
